/**
 * Product downloads
 *
 * Validates serial number and password with AJAX and
 * then renders download links
 */
var component_product_downloads = function(args) {

  // setup args
  var product_downloads = args.product_downloads;
  var form = product_downloads.querySelector('.product-downloads__form');

  // Resets from loading status to normal
  function resetForm() {
    submit_button.innerHTML = translations.str_login; // change button text back
    spinner.classList.remove('active'); // hide spinner
  }

  // Hides the form
  function hideForm() {
    form.classList.add('hidden');
  }

  // validate
  if (form) {
    var submit_button = form.querySelector('button[type=submit]');
    var spinner = form.querySelector('.product-downloads__form__spinner');
    var formData;
    var nonce;

    (function ($) {
      $(document).ready(function () {

        $(form).submit(function(e) {
          if (validateCredentials(e)) {
            renderDownloads(getDownloads(nonce));
          }
        });

        function validateCredentials(e) {
          var returnValue;
          formData = new FormData(form);
          formData.append('product_id', form.dataset.productId);
          e.preventDefault();
          $.ajax({
            url: senop_ajax_params.ajax_url,
            type: 'POST',
            data: formData,
            success: function(response) {
              if (response.type == 'valid') {
                alert(translations.str_login_successful);
                hideForm();
                returnValue = true;
                nonce = response.nonce;
              } else {
                resetForm();
                returnValue = false;
                alert(translations.str_incorrect_serial);
              }
            },
            beforeSend:function(xhr) {
              submit_button.innerHTML = translations.str_logging_in; // change button text
              spinner.classList.add('active'); // show spinner
            },
            error: function(response, status, xhr) {
              alert(translations.str_error);
              resetForm();
            },
            async: false,
            cache: false,
            contentType : false,
            processData : false,
            dataType: 'json' // expects json as response
          });

          return returnValue;
        }

        function getDownloads(nonce) {
          var downloads;

          $.ajax({
            url: senop_ajax_params.ajax_url,
            type: 'POST',
            data: {
              'action': 'senop_get_product_downloads',
              'product_id': form.dataset.productId,
              'nonce': nonce
            },
            success: function(response) {
              downloads = response;
            },
            error: function(response, status, xhr) {
              alert(translations.str_error);
              location.reload();
            },
            async: false,
            cache: false,
            dataType: 'html' // expects html as response
          });

          return downloads;
        }

        function renderDownloads(downloads) {
          product_downloads.querySelector('.product-downloads__downloads-private__title').classList.add('visible');
          $('.product-downloads__downloads-private').append(downloads);
        }
      });
    })(jQuery);
  }

  // make the call chainable
  return this;

};
